import { agentAxiosInstance } from "../config/axios";
import { AuthService } from "./authService";


export interface StreamData {
    type: "message" | "finished" | "error" | "api_constraint" | "ambiguous_request" | "clarification_needed" | "heartbeat" | "preview_building" | "preview_ready" | "preview_error" | "tool_activity";
    data?: string;
    message?: string;
    url?: string;
    timestamp?: number;
}


class AgentService {
    sendMessage = async (message: string, conversationId: string) => {
        const response = await agentAxiosInstance.post('agent/send-message', { message, conversationId });
        console.log(response.data);
        return response.data;
    }


    publish = async () => {
        const response = await agentAxiosInstance.get('/publish');
        return response.data;
    }

    getStatusStream = async (entityId: string, onMessage: (data: StreamData) => void, onError?: (error: Event) => void) => {
        let API_BASE_URL = "http://localhost:8001/api/agent"

        if (process.env.NODE_ENV === 'production') {
            API_BASE_URL = 'https://agent.mart-24.com/api/agent';
        }

        // EventSource cannot set headers; pass the Firebase ID token as a query param
        const token = await AuthService.getIdToken();
        const url = `${API_BASE_URL}/stream/${entityId}?token=${encodeURIComponent(token)}`;
        const eventSource = new EventSource(url);

        console.log('eventSource', eventSource);

        eventSource.onmessage = (event) => {
            try {
                const streamData: StreamData = JSON.parse(event.data);
                console.log('streamData', streamData);
                onMessage(streamData);
            } catch (error) {
                console.error('Error parsing SSE data:', error);
            }
        };

        eventSource.onerror = (error) => {
            console.error('SSE connection error:', error);
            if (onError) {
                onError(error);
            }
        };

        return eventSource;
    }

}

export const agentService = new AgentService();

export interface StatusResponse {
    completedTasks: string[]
    currentTask: string[]
    isCompleted: boolean
    agentReply: string
    previewUrl: string;
    currentStep: string;
    hasPreview: boolean;
    buildStatus: string;
    error: string | null;
    shouldStopPolling: boolean;
}

export interface PublishStatusResponse {
    currentStep: string;
    isCompleted: boolean;
    error?: string;
    success?: boolean;
}
